import React from 'react';
import { Link } from 'react-router-dom';
import 'isomorphic-fetch';

class Contact extends React.Component {
    state = {
        submitting: false,
        submitted: false,
        buttonState: '',
        formFields: {
            name: '',
            email: '',
            subject: '',
            phone: '',
            text: ''
        }
    };

    onSubmit = (e) => {
        e.preventDefault();
        const data = this.state.formFields;
        fetch('/api/contact', {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status === 200) {
                this.setState({ submitted: true })
            }
            let formFields = Object.assign({}, this.state.formFields);
            formFields.name = '';
            formFields.email = '';
            formFields.phone = '';
            formFields.subject = '';
            formFields.text = '';
            this.setState({formFields});
        });
    }

    nameChangeHandler = (e) => {
        let formFields = Object.assign({}, this.state.formFields);
        formFields.name = e.target.value;
        this.setState({formFields});
    }

    emailChangeHandler = (e) => {
        let formFields = Object.assign({}, this.state.formFields);
        formFields.email = e.target.value;
        this.setState({formFields});
    }

    phoneChangeHandler = (e) => {
        let formFields = Object.assign({}, this.state.formFields);
        formFields.phone = e.target.value;
        this.setState({formFields});
    }

    subjectChangeHandler = (e) => {
        let formFields = Object.assign({}, this.state.formFields);
        formFields.subject = e.target.value;
        this.setState({formFields});
    }

    textChangeHandler = (e) => {
        let formFields = Object.assign({}, this.state.formFields);
        formFields.text = e.target.value;
        this.setState({formFields});
    }

    onHideSuccess = () => {
        this.setState({submitted: false});
    }

    successMessage = () => {
        if (this.state.submitted){
            return (
                <div className="alert-success" uk-alert-success="true">
                    <Link to="#" onClick={this.onHideSuccess} className="uk-alert-close" uk-close="true"></Link>
                    <h3>Thank you</h3>
                    <p>We will connect you soon.</p>
                </div>
            );
        }
    }

    render(){
        return (
            <section id="contact" className="contact-area uk-contact uk-section">
                <div className="uk-container">
                    {this.successMessage()}

                    <h2>Return &amp; Refund Policy</h2>
                    <p>Thank you for visiting at <a href="https://www.rnditsolutions.com/" target="_blank" rel="noopener noreferrer">https://www.rnditsolutions.com/</a></p>
                    <p>If, for any reason, You are not completely satisfied with a purchase We invite You to review our policy on refunds.</p>

                    <hr />

                    <h3>NO RETURN &amp; NO REFUND POLICY</h3>
                    <p><strong>Effective Date:</strong> 26/11/2020</p>
                    <p><strong>Company Name:</strong> RND IT SOLUTIONS LIMITED</p>

                    <h4>1. Introduction</h4>
                    <p>At RND IT SOLUTIONS LIMITED, we strive to provide high-quality IT services, software solutions, hosting services, cloud infrastructure, domain registration, server management, web development, and related digital products. By purchasing any product or service from us, you acknowledge and agree to this No Return &amp; No Refund Policy.</p>

                    <h4>2. NO REFUND POLICY DUE TO SERVICE TERMS COMPLIANCE</h4>
                    <p>All payments made to RND IT SOLUTIONS LIMITED are final and non-refundable.</p>
                    <p>This policy applies to, but is not limited to:</p>
                    <ul>
                        <li>Web hosting services</li>
                        <li>VPS and dedicated server services</li>
                        <li>Cloud hosting services</li>
                        <li>Domain name registrations, renewals, and transfers</li>
                        <li>SSL certificates</li>
                        <li>Software licenses</li>
                        <li>Website development services</li>
                        <li>Mobile application development services</li>
                        <li>Digital products and downloads</li>
                        <li>Technical support services</li>
                        <li>Consultancy services</li>
                        <li>Managed IT services</li>
                        <li>Colocation and data center services</li>
                        <li>Any custom-configured solutions</li>
                        <li>Datacenter Solutions</li>
                        <li>Bangladesh and Foreign Webhosting Solutions</li>
                        <li>ERP Solutions</li>
                        <li>OTA or Online Travel Agency Software and Apps Development Solutions</li>
                    </ul>
                    <p>Once a service has been activated, provisioned, configured, delivered, or work order has been commenced, no refund shall be issued under any circumstances.</p>

                    <h4>3. NO RETURN POLICY</h4>
                    <p>Due to the nature of digital products and IT services, products and services purchased from RND IT SOLUTIONS LIMITED, under any circumstance there is no scope of return, exchange, or cancellation for a refund after delivery, activation, or deployment.</p>

                    <h4>4. Domain Registrations and Third-Party Services</h4>
                    <p>Domain registrations, renewals, transfers, SSL certificates, software licenses, and other third-party services are non-refundable because these products are processed immediately through external registries, vendors, and licensing authorities.</p>

                    <h4>5. Customer Responsibility</h4>
                    <p>Customers are responsible for:</p>
                    <ul>
                        <li>Reviewing service specifications before purchase.</li>
                        <li>Ensuring compatibility with their requirements.</li>
                        <li>Verifying all order details before submitting payment.</li>
                        <li>Understanding the features and limitations of the selected service plan.</li>
                    </ul>
                    <p>Failure to review product specifications or service descriptions shall not constitute grounds for a refund.</p>

                    <h4>6. Service Suspension or Termination</h4>
                    <p>Violation of our Terms of Service, Privacy Policy, applicable laws, or any misuse of services may result in suspension or termination without notice and without refund.</p>

                    <h4>7. Chargebacks and Payment Disputes</h4>
                    <p>Customers agree not to initiate chargebacks or payment disputes for services that have been delivered, activated, or provisioned. Unauthorized chargebacks may result in immediate suspension or termination of all associated services and accounts.</p>

                    <h4>8. EXCEPTIONS:</h4>
                    <p>Refunds may only be considered at the sole discretion of RND IT SOLUTIONS LIMITED only in the cases involving:</p>
                    <ul>
                        <li>Duplicate payments caused by a billing error.</li>
                        <li>Accidental overpayments verified by our finance department.</li>
                        <li>Situations where a service cannot be provisioned due to technical limitations solely attributable to RND IT SOLUTIONS LIMITED.</li>
                    </ul>
                    <p>Any exception shall not constitute a waiver of this policy.</p>

                    <h4>9. Policy Modifications</h4>
                    <p>RND IT SOLUTIONS LIMITED reserves the right to amend, modify, or update this policy at any time without prior notice. The latest version will be published on the company’s website.</p>

                    <h4>10. Contact Information</h4>
                    <p>For questions regarding this policy, please contact:</p>
                    <p>
                        <strong>RND IT SOLUTIONS LIMITED</strong><br />
                        Email: <a href="mailto:rnd.itsolutions.limited@gmail.com">rnd.itsolutions.limited@gmail.com</a><br />
                        Website: <a href="https://rnditsolutions.com/" target="_blank" rel="noopener noreferrer">https://rnditsolutions.com/</a>
                    </p>

                    <hr />
                    
                    <p><em><strong>By purchasing any product or service from RND IT SOLUTIONS LIMITED, you acknowledge that you have read, understood, and agreed to this No Return &amp; No Refund Policy.</strong></em></p>
                </div>
            </section>
        );
    }
}

export default Contact;
